import { useState, useEffect, createContext, useContext } from 'react';
import useToastNotification from 'hooks/useToastNotification';

import {
  getEmployment, getStampSubTotal, getHolidayUsingStatus,
  getOrganizationsTrees, getStamplist, getListStaffSelectBox
} from 'api/achievementConfirm';
import moment from 'moment';

import {
  IStampSubTotal, IHolidayUsingStatus, IStampList, IStaff, IOrganizationsTree
} from './interface';

export const getDateByClosingDate = (viewPeriod: string, closingDate: number, targetMonth: Date, isSelectCalendar: boolean, targetDateFrom: Date, 
  targetDateTo: Date) => {
  const newDate = new Date();
  const currentDay = Number(moment(newDate).format("DD"));
  let startOfMonth: any;
  let endOfMonth: any; 
  let targetDateFromStr = '';
  let targetDateToStr = '';
  const searchTargetDateFrom = sessionStorage.getItem('headquartersFinal.monthlyList.searchTargetDateFrom') || '';
  const searchTargetDateTo = sessionStorage.getItem('headquartersFinal.monthlyList.searchTargetDateTo') || '';
  const isGoBack = sessionStorage.getItem('headquartersFinal.monthlyList.isGoBack');

  if (viewPeriod === "daily") {
    targetDateFromStr = moment(new Date(targetDateFrom)).format('YYYY-MM-DD');
    targetDateToStr = moment(new Date(targetDateTo)).format('YYYY-MM-DD');
  } else if (searchTargetDateFrom && searchTargetDateTo && isGoBack === 'true') {
    targetDateFromStr = moment(new Date(searchTargetDateFrom)).format('YYYY-MM-DD');
    targetDateToStr = moment(new Date(searchTargetDateTo)).format('YYYY-MM-DD');
    sessionStorage.setItem('headquartersFinal.monthlyList.isGoBack', 'false');
  } else {
    if (closingDate === 0 || closingDate === null) {
      startOfMonth = moment(targetMonth).startOf('month').format('YYYY-MM-DD');
      endOfMonth = moment(targetMonth).endOf('month').format('YYYY-MM-DD');
    } else { 
      targetMonth.setDate(closingDate);
      startOfMonth = moment(targetMonth).add(1, 'day').subtract(1, 'month').format('YYYY-MM-DD');
      endOfMonth = moment(targetMonth).format('YYYY-MM-DD');
    }
    targetDateFromStr = moment(new Date(startOfMonth)).format('YYYY-MM-DD');
    targetDateToStr = moment(new Date(endOfMonth)).format('YYYY-MM-DD');
  }

  return {
    targetDateFromStr,
    targetDateToStr
  }
}

type ContextType = {
  targetDateFrom: Date,
  setTargetDateFrom: React.Dispatch<React.SetStateAction<Date>>;

  targetDateTo: Date,
  setTargetDateTo: React.Dispatch<React.SetStateAction<Date>>;

  staffCode: string,
  setStaffCode: React.Dispatch<React.SetStateAction<string>>;

  targetMonth: Date,
  setTargetMonth: React.Dispatch<React.SetStateAction<Date>>;

  orgCode: string,
  setOrgCode: React.Dispatch<React.SetStateAction<string>>;

  selectOrgCode: string;
  setSelectOrgCode: React.Dispatch<React.SetStateAction<string>>;

  viewPeriod: string,
  setViewPeriod: React.Dispatch<React.SetStateAction<string>>;

  flagReLoad: number | undefined,
  setFlagReload: React.Dispatch<React.SetStateAction<number | undefined>>;

}
// export const initStates = {
//   targetDateFrom: new Date(),
//   targetDateTo: new Date(),
//   staffCode: '',
//   targetMonth: '',
//   orgCode: '',
//   selectOrgCode: '',
//   viewPeriod: 'monthly',
//   flagReLoad: false
// }

const setInitClosingDate = () => {
  const newDate = new Date();
  const currentDay = Number(moment(newDate).format("DD"));
  const closingDate = Number(sessionStorage.getItem('loginUser.closingDate'));
  let firstDayStr: any;
  let lastDayStr: any;
  const searchTargetDateFrom = sessionStorage.getItem('headquartersFinal.monthlyList.searchTargetDateFrom') || '';
  const searchTargetDateTo = sessionStorage.getItem('headquartersFinal.monthlyList.searchTargetDateTo') || '';
  if (searchTargetDateFrom && searchTargetDateTo) {
    firstDayStr = searchTargetDateFrom;
    lastDayStr = searchTargetDateTo;
    sessionStorage.setItem('attendStampList.attendStampForm', firstDayStr);
    sessionStorage.setItem('attendStampList.attendStampTo', lastDayStr);
  } else {
    if (closingDate === 0) {
      firstDayStr = moment().startOf('month').format('YYYY-MM-DD');
      lastDayStr = moment().endOf('month').format('YYYY-MM-DD');
    } else if (currentDay > closingDate) {
      newDate.setDate(closingDate);
      firstDayStr = moment(newDate).add(1, 'day').format('YYYY-MM-DD');
      lastDayStr = moment(newDate).add(1, 'month').format('YYYY-MM-DD');
    } else {
      newDate.setDate(closingDate);
      firstDayStr = moment(newDate).subtract(1, 'month').add(1, 'day').format('YYYY-MM-DD');
      lastDayStr = moment(newDate).format('YYYY-MM-DD');
    }
  }

  return {
    firstDayStr,
    lastDayStr
  }
}

export const attendStampContext = createContext<ContextType>({} as ContextType);
export const useAttendStampContext = (): ContextType => {
  const context = useContext(attendStampContext);
  return context;
};

export const useIntialState = () => {
  const { firstDayStr, lastDayStr } = setInitClosingDate();
  const [targetDateFrom, setTargetDateFrom] = useState(sessionStorage.getItem('attendStampList.targetDateFrom') ? new Date(sessionStorage.getItem('attendStampList.targetDateFrom')!) : new Date(firstDayStr));
  const [targetDateTo, setTargetDateTo] = useState(sessionStorage.getItem('attendStampList.targetDateTo') ? new Date(sessionStorage.getItem('attendStampList.targetDateTo')!) : new Date(lastDayStr));
  const [staffCode, setStaffCode] = useState(sessionStorage.getItem('attendStampList.staffCode')! || sessionStorage.getItem('loginUser.staffCode')!);
  const [targetMonth, setTargetMonth] = useState(new Date(sessionStorage.getItem('attendStampList.targetMonth') || new Date(lastDayStr)));
  const [orgCode, setOrgCode] = useState(sessionStorage.getItem('attendStampList.orgCode')! || sessionStorage.getItem('loginUser.orgCode')!);
  const [selectOrgCode, setSelectOrgCode] = useState(sessionStorage.getItem('attendStampList.orgCode')! || sessionStorage.getItem('loginUser.orgCode')!);
  const [viewPeriod, setViewPeriod] = useState(sessionStorage.getItem('headquartersFinal.viewPeriod') || sessionStorage.getItem('attendStampList.viewPeriod') || 'monthly');
  const [flagReLoad, setFlagReload] = useState<number | undefined>();
  const [isReloader, setIsReloader] = useState(false);

  const [orgCodeList, setOrgCodeList] = useState<any>([]); 
  
  return {
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    staffCode,
    setStaffCode,
    targetMonth,
    setTargetMonth,
    orgCode,
    setOrgCode,
    selectOrgCode,
    setSelectOrgCode,
    viewPeriod,
    setViewPeriod,
    flagReLoad,
    setFlagReload,
    setIsReloader,
    isReloader,
    orgCodeList,
    setOrgCodeList
  }
}

export const useStampListForm = (
  closingDate: number,
  attendFlag: string,
  selectedEmploymentId: string,
  setSubTotalTime: any,
  setSubTotalDay: any,
  setHolidaySubtotalItem: any,
  setAttendHolidays: any,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setTerm: any,
  setBusiness: any,
  isSelectCalendar: boolean,
  setOldSelectOrgCode: any,
  targetDateFrom: Date,
  setTargetDateFrom: React.Dispatch<React.SetStateAction<Date>>,
  targetDateTo: Date,
  setTargetDateTo: React.Dispatch<React.SetStateAction<Date>>,
  staffCode: string,
  setStaffCode: React.Dispatch<React.SetStateAction<string>>,
  targetMonth: Date,
  setTargetMonth: React.Dispatch<React.SetStateAction<Date>>,
  orgCode: string,
  setOrgCode: React.Dispatch<React.SetStateAction<string>>,
  selectOrgCode: string,
  setSelectOrgCode: React.Dispatch<React.SetStateAction<string>>,
  viewPeriod: string,
  setViewPeriod: React.Dispatch<React.SetStateAction<string>>,
  flagReLoad: number | undefined,
  setFlagReload: React.Dispatch<React.SetStateAction<number | undefined>>,
  isReloader: boolean,
  setIsReloader: React.Dispatch<React.SetStateAction<boolean>>,
  setOrgCodeList: React.Dispatch<React.SetStateAction<any>>,
  oldOrgCode: string
) => {
  const [employment, setEmployment] = useState(Object())
  const siteType = sessionStorage.getItem('loginUser.site') || '';
  // Staff
  const [staffList, setStaffList] = useState([]);

  // Stamp
  const [stampItems, setStampItems] = useState([]);
  const [stampBusiness, setStampBusiness] = useState([]);
  const [stampTerm, setStampTerm] = useState([]);
  const { errorNotification } = useToastNotification();

  // HolidayUsingStatus
  const [paidHolidayGrantData, setPaidHolidayGrantData] = useState(Object());
  const [specialHolidayGrantList, setSpecialHolidayGrantList] = useState([]);
  const [substituteHolidayUsingStatusList, setSubstituteHolidayUsingStatusList] = useState([]);
  const [transferHolidayUsingStatusList, setTransferHolidayUsingStatusList] = useState([]);
  const [nursingCareHolidayData, setNursingCareHolidayDataList] = useState([]);
  const [nursingHolidayData, setNursingHolidayDataList] = useState([]);
  const [isConfirmError, setIsConfirmError] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [isConfirmAchievement, setIsConfirmAchievement] = useState(false); 
  
  const { targetDateFromStr, targetDateToStr } = getDateByClosingDate(
    viewPeriod,
    closingDate, 
    targetMonth, 
    isSelectCalendar, 
    targetDateFrom,
    targetDateTo
  );

  useEffect(() => {
    const params = {
      orgCode,
      targetDateFrom: moment(new Date(targetDateFromStr)).format('YYYY年MM月DD日'),
      targetDateTo: moment(new Date(targetDateToStr)).format('YYYY年MM月DD日'),
      staffCode: staffCode || sessionStorage.getItem('loginUser.staffCode'),
    };

    if (moment(targetDateTo).diff(targetDateFrom, 'year') >= 1) {
      errorNotification('対象期間の範囲は１年以内で入力してください');
      return;
    }
    if(isReloader === true) {
      getEmployment(params).then((response: any) => {
        setEmployment(response);
        const { targetDateFromStr, targetDateToStr } = getDateByClosingDate(viewPeriod, response.closingDate, targetMonth, isSelectCalendar, targetDateFrom, targetDateTo);
        setTargetDateFrom(new Date(targetDateFromStr));
        setTargetDateTo(new Date(targetDateToStr));
        setIsLoading(true);
        getOrganizationsTrees({
          siteType: String(siteType) === '3' ? 'HQ' : (String(siteType) === '2' ? 'SHOP' : 'PERSONAL'),
          orgCode: sessionStorage.getItem('loginUser.orgCode'),
          targetDayFrom: moment(targetDateFromStr).format('YYYY-MM-DD'),
          targetDayTo: moment(targetDateToStr).format('YYYY-MM-DD'),
          staffCode: sessionStorage.getItem('loginUser.staffCode'),
        }).then((response) => {

          setOrgCodeList(response.map((item: any) => ({
            value: String(item.orgCode),
            label: `${item.orgCode} ${item.orgName}`,
          }))); 
          
          // Staffs
          fetchStaffs({
            targetDateFrom: new Date(targetDateFromStr),
            targetDateTo: new Date(targetDateToStr),
            orgCode: selectOrgCode,
            attendFlag,
            selectedEmploymentId,
            siteType,
            staffCode,
            setStaffList
          });
  
          if (response.length === 0) {
            errorNotification('選択した期間は組織がありません。');
            setIsLoading(false);
            sessionStorage.setItem('attendStampList.targetDateFrom', targetDateFromStr);
            sessionStorage.setItem('attendStampList.targetDateTo', targetDateToStr);
            setStampBusiness([]);
            setStampTerm([]);
            setSubTotalTime({});
            setSubTotalDay({});
            setHolidaySubtotalItem([]);
            setAttendHolidays([]);
            setStampItems([]);
            setStaffList([]);
            return;
          } else if ((oldOrgCode !== selectOrgCode) || response.filter((orgItem) => orgItem.orgCode === selectOrgCode).length === 0) {
            setStampBusiness([]);
            setIsLoading(false);
            setStampTerm([]);
            setSubTotalTime({});
            setSubTotalDay({});
            setHolidaySubtotalItem([]);
            setAttendHolidays([]);
            setStampItems([]);
            // setStaffList([]);
            setStaffCode('');
            setOldSelectOrgCode(selectOrgCode);
            return;
          }
          
          // Stamplist
          fetchStampList({
            targetDateFrom: new Date(targetDateFromStr),
            targetDateTo: new Date(targetDateToStr),
            attendFlag,
            staffCode,
            orgCode: selectOrgCode,
            setStampItems,
            setStampBusiness,
            setStampTerm,
            setIsConfirmError,
            setIsConfirmAchievement,
            setSubTotalTime,
            setSubTotalDay,
            setHolidaySubtotalItem,
            setAttendHolidays,
            errorNotification,
            setIsLoading
          });
  
          // holidayUsingStatus
          fetchHolidayUsingStatus({
            targetDateFrom: new Date(targetDateFromStr),
            targetDateTo: new Date(targetDateToStr),
            staffCode,
            setPaidHolidayGrantData,
            setSpecialHolidayGrantList,
            setSubstituteHolidayUsingStatusList,
            setTransferHolidayUsingStatusList,
            setNursingCareHolidayDataList,
            setNursingHolidayDataList
          });
  
          // stampSubTotal
          fetchStampSubTotal({
            staffCode,
            orgCode: selectOrgCode,
            attendFlag,
            setTerm,
            setBusiness,
            setAttendHolidays,
            setSubTotalTime,
            setSubTotalDay,
            setHolidaySubtotalItem,
            targetDateFrom: new Date(targetDateFromStr),
            targetDateTo: new Date(targetDateToStr)
          });
        }).catch(() => { 
          setIsLoading(false);
        });
      });

      setIsReloader(false);
    } else {
      setIsLoading(false);
    }

  }, [isReloader]);

  return {
    employment,
    setEmployment,
    closingDate,
    setViewPeriod,
    setTargetMonth,
    viewPeriod,
    targetMonth,
    orgCode,
    staffList,
    setStaffList,
    stampItems,
    stampBusiness,
    stampTerm,
    paidHolidayGrantData,
    specialHolidayGrantList,
    substituteHolidayUsingStatusList,
    transferHolidayUsingStatusList,
    nursingCareHolidayData,
    nursingHolidayData,
    flagReLoad,
    targetDateFromStr,
    targetDateToStr,
    isConfirmError,
    setIsReload,
    isReload,
    isConfirmAchievement,
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    staffCode,
    setStaffCode,
    setOrgCode,
    selectOrgCode,
    setSelectOrgCode,
    setFlagReload,
  };
};

export const fetchStaffs = async (
  iStaff: IStaff
) => {
  const {
    targetDateFrom,
    targetDateTo,
    orgCode,
    attendFlag,
    selectedEmploymentId,
    siteType,
    staffCode,
    setStaffList
  } = iStaff;

  const params = {
    orgCode,
    targetDayFrom: moment(new Date(targetDateFrom)).format('YYYY-MM-DD'),
    targetDayTo: moment(new Date(targetDateTo)).format('YYYY-MM-DD'),
    attendStaff: attendFlag,
    stateStatus: '1, 3, 4',
    employmentId: selectedEmploymentId,
  };
  
  let staffListTmp;
  await getListStaffSelectBox(params).then((response: any) => {
    staffListTmp = response.map((item: any) => ({
      value: String(item.staffCode),
      label: `${item.staffCode} ${item.staffName}`,
    }));

    console.log('staffListTmp',staffListTmp);

    if (String(siteType) === '1') {
      staffListTmp = staffListTmp.filter((item: any) => String(item.value) === String(staffCode));
    }
    setStaffList(staffListTmp);
  });

  return {
    staffListTmp
  }
}

export const fetchStampList = async (
  iStampList: IStampList
) => {
  const {
    targetDateFrom,
    targetDateTo,
    attendFlag,
    staffCode,
    orgCode,
    setStampItems,
    setStampBusiness,
    setStampTerm,
    setIsConfirmError,
    setIsConfirmAchievement,
    setSubTotalTime,
    setSubTotalDay,
    setHolidaySubtotalItem,
    setAttendHolidays,
    errorNotification,
    setIsLoading
  } = iStampList;

  const params = {
    periodFrom: moment(new Date(targetDateFrom)).format('YYYY-MM-DD'),
    periodTo: moment(new Date(targetDateTo)).format('YYYY-MM-DD'),
    attendFlag,
    staffCode,
    orgCode: orgCode,
  }; 
  
  await getStamplist(params).then((data: any) => {
    setStampItems(data.attendStampDataList);
    setStampBusiness(data.business);
    setStampTerm(data.term);
    setIsConfirmError(data.isConfirmError);
    setIsConfirmAchievement(data.isAchivementConfirm);
  }).catch((error) => { 
    setStampBusiness([]);
    setStampTerm([]);
    setSubTotalTime({});
    setSubTotalDay({});
    setHolidaySubtotalItem([]);
    setAttendHolidays([]);
    setStampItems([]);
    if (error.response && error.response.status === 400) {
      console.log('400');
    } else if (error.response && error.response.data && error.response.data.errors) {
      let msgError = '';
      error.response.data.errors.map((item: { defaultMessage: string; }) => {
        msgError += `${item.defaultMessage} </br>`;
        return msgError;
      });
      errorNotification(msgError);
    }
  }).finally(() => {
    setIsLoading(false);
  });
}

export const fetchHolidayUsingStatus = (
  iHolidayUsingStatus: IHolidayUsingStatus
) => {
  const {
    targetDateFrom,
    targetDateTo,
    staffCode,
    setPaidHolidayGrantData,
    setSpecialHolidayGrantList,
    setSubstituteHolidayUsingStatusList,
    setTransferHolidayUsingStatusList,
    setNursingCareHolidayDataList,
    setNursingHolidayDataList
  } = iHolidayUsingStatus;

  const params = {
    targetDateFrom: moment(new Date(targetDateFrom)).format('YYYY-MM-DD'),
    targetDateTo: moment(new Date(targetDateTo)).format('YYYY-MM-DD'),
    staffCode,
  };

  getHolidayUsingStatus(params).then((data: any) => {
    
    if (data.paidHolidayGrantData != null) {
      setPaidHolidayGrantData(data.paidHolidayGrantData);
    }else {
      setPaidHolidayGrantData([]);
    }

    if (data.specialHolidayGrantList != null) {
      setSpecialHolidayGrantList(data.specialHolidayGrantList);
    } else {
      setSpecialHolidayGrantList([]);
    }
    if (data.substituteHolidayUsingStatusList != null) {
      setSubstituteHolidayUsingStatusList(data.substituteHolidayUsingStatusList);
    } else {
      setSubstituteHolidayUsingStatusList([]);
    }

    if (data.transferHolidayUsingStatusList != null) {
      setTransferHolidayUsingStatusList(data.transferHolidayUsingStatusList);
    } else {
      setTransferHolidayUsingStatusList([]);
    }

    if (data.nursingCareHolidayData != null) {
      setNursingCareHolidayDataList(data.nursingCareHolidayData);
    } else {
      setNursingCareHolidayDataList([]);
    }

    if (data.nursingHolidayData != null) {
      setNursingHolidayDataList(data.nursingHolidayData);
    } else {
      setNursingHolidayDataList([]);
    }
  });
}

export const fetchStampSubTotal = (
  iStampSubTotal: IStampSubTotal
) => {
  const {
    orgCode,
    targetDateFrom,
    targetDateTo,
    staffCode,
    attendFlag,
    setBusiness,
    setTerm,
    setAttendHolidays,
    setSubTotalTime,
    setSubTotalDay,
    setHolidaySubtotalItem
  } = iStampSubTotal;
  const params = {
    orgCode,
    periodFrom: moment(new Date(targetDateFrom)).format('YYYY-MM-DD'),
    periodTo: moment(new Date(targetDateTo)).format('YYYY-MM-DD'),
    staffCode,
    attendFlag,
  };

  getStampSubTotal(params).then((response: any) => {
    setBusiness(response.business);
    setTerm(response.term);
    setAttendHolidays(response.attendHolidays);
    setSubTotalTime(response.attendStampSubTotalTime[0]);
    setSubTotalDay(response.attendStampSubTotalDay[0]);
    setHolidaySubtotalItem(response.holidaySubtotalItem);
  })
}

export const fetchOrganizationsTrees = (
  IOrganizationsTree: IOrganizationsTree
) => {
  const {
    siteType,
    orgCode,
    targetDateFrom,
    targetDateTo,
    staffCode,
    setOrgCodeList
  } = IOrganizationsTree;

  const params = {
    siteType: String(siteType) === '3' ? 'HQ' : (String(siteType) === '2' ? 'SHOP' : 'PERSONAL'),
    orgCode,
    targetDayFrom: moment(new Date(targetDateFrom)).format('YYYY-MM-DD'),
    targetDayTo: moment(new Date(targetDateTo)).format('YYYY-MM-DD'),
    staffCode,
  };

  getOrganizationsTrees(params).then((response: any) => {
    setOrgCodeList(response.map((item: any) => ({
      value: String(item.orgCode),
      label: `${item.orgCode} ${item.orgName}`,
    })));
  });
}

export const downloadOriginalPDF = async (response: any, downloadFileName: string) => {
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  const file = new Blob([bom, response], {
    type: 'application/pdf',
  });
  saveAs(file, downloadFileName);
};

export const eventScroll = (e: { target: any; }) => {
  const { target } = e;
  const contentRight = document.getElementById('bottomRightAreaTime');
  const headRight = document.getElementById('topRightAreaTime');
  const scrollBottom = document.getElementById('scrollBottom');
  if (contentRight && headRight && scrollBottom) {
    contentRight.scrollLeft = target.scrollLeft;
    headRight.scrollLeft = target.scrollLeft;
    scrollBottom.scrollLeft = target.scrollLeft;
  }
};

export default {
  useStampListForm,
  eventScroll,
};

